import axios from 'axios';
import APIURL from '../common/Config';
import { encodeRequestData, decodeResponseData } from '../utils/apiSecurity';

const ApiManager = {
  fetchAstrologerAccountDetails: async (msisdn) => {
    try {
      const response = await axios.get(`${APIURL}/astroservice/login/asastrologer/${msisdn}`);
      await ApiManager.storeData('ASTROLOGERID', response.data.astrologerId);

      console.log('API URL:', `${APIURL}/astroservice/login/asastrologer/${msisdn}`);
      console.log('Response:', response.data);

      if (response.data && response.data.astrologerId > 0) {
        return {
          status: 1,
          errorMsg: "Astrologer Record Found",
          astrologerId: response.data.astrologerId,
          astrologerName: response.data.astrologerName,
          msisdn: response.data.msisdn,
        };
      } else {
        console.error('Error response Login:', response.data);
        return {
          status: 0,
          errorMsg: "Astrologer Record not found",
          astrologerId: 0,
          astrologerName: "",
          msisdn: msisdn,
        };
      }
    } catch (error) {
      console.error('Error fetching astrologer details:', error.message);
      return {
        status: -1,
        errorMsg: error.message,
        astrologerId: 0,
        astrologerName: "",
        msisdn: msisdn,
      };
    }
  },

  registerAsAstrologer: async (astrologerDetails) => {
    try {
      const response = await axios.post(`${APIURL}/astroservice/register/astrologer`, astrologerDetails);
      if (response.data && response.data.astrologerId) {
        await ApiManager.storeData('ASTROLOGERID', response.data.astrologerId);
      }
      return response.data;
    } catch (error) {
      console.error('Error registering astrologer:', error.message);
      throw error;
    }
  },

  storeData: async (key, value) => {
    try {
      const jsonValue = JSON.stringify(value);
      localStorage.setItem(key, jsonValue);
      console.log(`Data successfully saved under key "${key}"!`);
    } catch (error) {
      console.error('Error storing data:', error);
    }
  },

  getData: async (key) => {
    try {
      const jsonValue = localStorage.getItem(key);
      return jsonValue != null ? JSON.parse(jsonValue) : null;
    } catch (error) {
      console.error('Error retrieving data:', error);
      return null;
    }
  },

  pushOtpToMsisdn: async (msisdn) => {
    try {
      const originalRequestData = ApiManager.prepareDataForGetOtpRequest(msisdn);
      const finalPayloadForAPI = encodeRequestData(originalRequestData);

      console.log("Sending final JSON payload:", finalPayloadForAPI);

      const response = await axios.post(`${APIURL}/otp/service`, finalPayloadForAPI);

      // const decodedResponse = decodeResponseData(response.data.encodedResponse);
      const decodedResponse = decodeResponseData(response.data);
      console.log("pushOtpToMsisdn Decoded Response:", decodedResponse);
      return decodedResponse;
    } catch (error) {
      console.error('Error sending OTP:', error.message);
      throw error;
    }
  },

  initiateAstroRegistrationData: (msisdn) => ({
    status: -1,
    errorMsg: "",
    astrologerId: 0,
    astrologerName: "",
    msisdn,
    age: 18,
    apptCharges: 1000,
    callCharges: 10,
    callCount: 0,
    chatCharges: 10,
    chatCount: 0,
    ecallCharges: 50,
    echatCharges: 20,
    emailId: "NA",
    experience: 0,
    firstName: "",
    gender: "M",
    language: "ENGLISH",
    lastCallTime: "",
    lastChatTime: null,
    lastName: "",
    lastVcallTime: null,
    mobileNo: "",
    nickName: "",
    photoUrlpath: "",
    rating: 10,
    registrationDate: null,
    specialization: "ASTROLOGY",
    statusDescp: "",
    vcallCount: 0,
    videoCallCharges: 50,
  }),

  prepareAstrologerDataForLocalStorage: async (astrologerData) => {
    return {
      status: astrologerData.status,
      astrologerId: astrologerData.astrologerId,
      astrologerName: astrologerData.astrologerName,
      msisdn: astrologerData.msisdn,
      age: astrologerData.age,
      apptCharges: astrologerData.apptCharges,
      callCharges: astrologerData.callCharges,
      chatCharges: astrologerData.chatCharges,
      ecallCharges: astrologerData.ecallCharges,
      echatCharges: astrologerData.echatCharges,
      emailId: astrologerData.emailId,
      experience: astrologerData.experience,
      firstName: astrologerData.firstName,
      gender: astrologerData.gender,
      language: astrologerData.language,
      lastName: astrologerData.lastName,
      mobileNo: astrologerData.mobileNo,
      nickName: astrologerData.nickName,
      photoUrlpath: astrologerData.photoUrlpath,
      rating: astrologerData.rating,
      registrationDate: astrologerData.registrationDate,
      specialization: astrologerData.specialization,
      videoCallCharges: astrologerData.videoCallCharges
    };
  },

  prepareDataForGetOtpRequest: (msisdn) => ({
    requestType: 'SEND-OTP',
    msisdn,
    otpPin: '',
    userCatg: '',
    userId: '',
    emailId: '',
    name: '',
    latitude: '37.4219862',
    longitude: '-122.0842771',
    timeStamp: new Date().toISOString(),
    otpSessionId: '',
    reqTime: new Date().toISOString(),
  }),
};

export default ApiManager;